<template>
  <q-layout>
    <div class="page-header">
      <q-toolbar-title class="text-5 q-mr-auto q-ma-sm">{{ $t('log_creatives') }}</q-toolbar-title>
      <q-breadcrumbs class="q-mr-auto q-ma-sm">
        <q-breadcrumbs-el :label="$t('dashboard')" to="/" />
        <q-breadcrumbs-el :label="$t('log')" />
        <q-breadcrumbs-el :label="$t('creatives')" exact />
      </q-breadcrumbs>
    </div>
    <q-page padding>
      <header-creative-log />
      <list-creative-log />
    </q-page>
  </q-layout>
</template>

<script>
import HeaderCreativeLog from '../../components/creative/HeaderCreativeLog.vue';
import ListCreativeLog from '../../components/creative/ListCreativeLog.vue';

export default {
  name: 'CreativeLogList',
  components: { HeaderCreativeLog, ListCreativeLog }
};
</script>
